import React from 'react'
import { FlightSearchWidgetDispatchAction } from './flightSearchWidgetStateReducer'
import noop from 'lib/function/noop'

const FlightSearchWidgetDispatchContext = React.createContext<React.Dispatch<FlightSearchWidgetDispatchAction>>(noop)

export default FlightSearchWidgetDispatchContext
